/** Same bounded frame regardless of title length: 200px thumbnail, 22rem copy,
 * 12px gap, 24px padding and 2px border. Narrow containers shrink both equally. */
export const supportingMediaCard = 'w-full max-w-[calc(200px+22rem+2.375rem)] rounded-inset border border-rule bg-elevated/40 p-3';
export const supportingMediaRow = 'flex flex-col gap-3 sm:flex-row sm:items-start';
export const supportingMediaThumbnail = 'relative block aspect-video w-full shrink-0 overflow-hidden rounded-inset border border-rule bg-canvas sm:w-[200px]';
export const supportingMediaCopy = 'min-w-0 flex-1 sm:max-w-[22rem]';
